import { TFile } from './storage.types';
import {
  EVerificationStatus,
  EVerificationStatusUi,
  TFileDataType,
} from './generalTypes';

export enum EHPVisitationUI {
  REMOTE = 'REMOTE',
  IN_PERSON = 'IN_PERSON',
}
export enum EHPVisitation {
  REMOTE = 'REMOTE',
  IN_PERSON = 'IN_PERSON',
}

export enum EHPDocPacketTypesUI {
  SA = 'SA',
  ESA = 'ESA',
}
export enum EHPDocPacketTypes {
  SA = 'SA',
  ESA = 'ESA',
}

export enum ETemplateTypeUI {
  MENTAL_HEALTH_PROFESSIONAL = 'MENTAL_HEALTH_PROFESSIONAL',
  SERVICES_TRAINED = 'SERVICES_TRAINED',
}
export enum ETemplateType {
  MENTAL_HEALTH_PROFESSIONAL = 'MENTAL_HEALTH_PROFESSIONAL',
  SERVICES_TRAINED = 'SERVICES_TRAINED',
}

export type THPDocFieldUpdateUI = {
  documentPacketId: string;
  value: string;
};

export type THPVisitationUI = { type: EHPVisitationUI; websites?: string[] };
export type THPVisitation = { type: EHPVisitation; websites?: string[] };

export type THPVisitationGetUI = THPVisitationUI;
export type THPVisitationGet = {
  type: EHPVisitation;
  websites?: { value: string }[];
};

export type THPContactInfoUI = {
  name?: string;
  emailAddress?: string;
  phoneNumber?: string;
  faxNumber?: string;
};
export type THPContactInfo = THPContactInfoUI;

export type TNameUpdateUI = THPDocFieldUpdateUI;
export type TNameUpdate = {
  documentPacketId: string;
  hpContactName: string | null;
};

export type TEmailUpdateUI = THPDocFieldUpdateUI;
export type TEmailUpdate = {
  documentPacketId: string;
  hpContactEmail: string | null;
};

export type TPhoneUpdateUI = THPDocFieldUpdateUI;
export type TPhoneUpdate = {
  documentPacketId: string;
  hpContactPhone: string | null;
};

export type TFaxUpdateUI = THPDocFieldUpdateUI;
export type TFaxUpdate = {
  documentPacketId: string;
  hpContactFaxNumber: string | null;
};

export type THPVisitationUpdateUI = {
  documentPacketId: string;
  hpVisitation: THPVisitationUI;
};
export type THPVisitationUpdate = {
  documentPacketId: string;
  hpVisitation: THPVisitation;
};

export type THPLetterUpdateUI = {
  hpDocumentPacketId: string;
  newHpLetters: TFile[];
  removedDocumentsIds?: string[];
};
export type THPLetterUpdate = {
  documentPacketId: string;
  newHpLetters: TFile[];
  removedHpLetterIds?: string[];
};

export type TDocPacketUI = {
  hpDocType?: EHPDocPacketTypesUI;
  name: string;
  emailAddress?: string;
  phoneNumber?: string;
  faxNumber?: string;
  websites?: string[];
  hpVisitation: EHPVisitationUI;
  hpDocPacketLetter?: TFile[];
};
export type TDocPacket = {
  hpDocType?: EHPDocPacketTypes;
  hpContactInfo: THPContactInfo;
  hpVisitation?: THPVisitation;
  hpDocPacketLetter?: TFile[];
};

export type TDocPacketGetUI = {
  type: EHPDocPacketTypesUI;
  hpContactInfo: THPContactInfoUI;
  hpDocForms?: TFileDataType[];
  hpVisitation: EHPVisitationUI;
  websites?: string[];
  hpDocLetters?: TFileDataType[];
  canEdit: boolean;
  status: EVerificationStatusUi;
  hpDocumentPacketId: string;
};
export type TDocPacketGet = {
  type: EHPDocPacketTypes;
  hpContactInfo: THPContactInfo;
  hpDocForms?: TFileDataType[];
  hpVisitation: THPVisitationGet;
  hpDocLetters?: TFileDataType[];
  modifiable: boolean;
  verificationStatus: EVerificationStatus;
  hpDocumentPacketId: string;
};
